<div class="cx-modal-container add-to-cart-popup-container" [cxFocus]="focusConfig"
  (esc)="dismissModal('Escape pressed')">
  <div class="cx-modal-content add-to-cart-dialog">
    <!-- Modal Header -->
    <ng-container *ngIf="loaded$ | async">
      <div class="cx-dialog-header modal-header add-to-cart-header">
        <div class="cx-dialog-title modal-title">
          {{
          (addedEntryWasMerged$ | async)
          ? ('common.basket_added_to_basket' | cxTranslate)
          : ('common.basket_added_to_basket' | cxTranslate)
          }}
        </div>
        <button type="button" class="closed" attr.aria-label="{{ 'addToCart.closeModal' | cxTranslate }}"
          (click)="dismissModal('Cross click')">
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="cx-dialog-body modal-body" *ngIf="$any(entry$) | async as entry">
        <!-- <p>{{entry}}</p> -->
        <div class="cx-dialog-row">
          <div class="cx-dialog-item col-sm-12 col-md-12">
            <div class="mini-cart-insideBlock row">
              <ol class="col-sm-12 col-md-12 col-lg-7 mini-cart-list ">
                <li class="mini-cart-item row">
                  <div class="thumb width-auto">
                    <a [routerLink]=" 
                              {  cxRoute: 'product',
                             params: entry?.['product']
                              } | cxUrl ">
                      <cx-media class="cx-product-image img-icon cart-img-icon"
                        [container]="entry?.['product']?.images?.PRIMARY || entry?.['product']?.images || null "
                        format="product"
                        [alt]="entry?.['product']?.name || entry?.['product']?.summary || 'noimage'"></cx-media>
                    </a>
                  </div>
                  <div class="details" *ngIf="!isMobile">
                    <a [routerLink]=" {  cxRoute: 'product',
                             params: entry?.['product']
                              } | cxUrl " class="product-code">{{entry?.['product']?.code}}</a>
                    <p class="prod-desc">{{entry?.['product']?.name}}</p>
                    <p [routerLink]=" {  cxRoute: 'product',
                             params: entry?.['product']
                              } | cxUrl " class="prod-desc">
                      {{entry?.['product']?.typenumber}}</p>
                    <p class="prod-green mb-0">{{entry?.['product']?.salesStatus}}</p>
                    <p class="prod-green" style="white-space: nowrap;">{{entry?.['product']?.marketType}}</p>
                  </div>
                  <ng-container *ngIf="isMobile">
                    <div class="details">
                      <div class="col-12 col-sm-5"> <a [routerLink]=" {  cxRoute: 'product',
                             params: entry?.['product']
                              } | cxUrl " class="product-code">{{entry?.['product']?.code}}</a>
                        <p [routerLink]=" {  cxRoute: 'product',
                             params: entry?.['product']
                              } | cxUrl " class="prod-desc">
                          {{entry?.['product']?.name}}</p>
                        <p [routerLink]=" {  cxRoute: 'product',
                             params: entry?.['product']
                              } | cxUrl " class="prod-desc">
                          {{entry?.['product']?.typenumber}}</p>
                        <p class="prod-green mb-0">{{entry?.['product']?.salesStatus}}</p>
                        <p class="prod-green" style="white-space: nowrap;">{{entry?.['product']?.marketType}}</p>

                      </div>
                      <div class="col-12 col-sm-7">
                        <ng-container *ngIf="showNetPrice$|async">
                          <div class="rower" *ngIf="this.custIDService.fleetPrideGroup$|async as fleetPrideGroup">
                            <div class="prod-desc">
                              {{'common.popup_cart_customer_price'|cxTranslate}}</div>
                            <div class="price">
                              <span *ngIf="entry?.['product']?.netPrice?.formattedValue ; else OnPrice">
                                <strong>
                                  {{entry?.['product']?.netPrice?.formattedValue}}&nbsp;&nbsp;{{entry?.['product']?.netPrice?.currencyIso}}
                                </strong>
                              </span>
                              <ng-template
                                #OnPrice><span><strong>{{'common.basket_page_poa'|cxTranslate}}</strong></span></ng-template>
                            </div>
                          </div>
                        </ng-container>
                        <div class=" rower">
                          <div class="prod-desc">
                            {{'common.popup_cart_quantity_added'|cxTranslate}} </div>
                          <div class="price">{{entry?.['quantity']}}</div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </li>

              </ol>
              <div class="col-sm-5 col-md-5" *ngIf="!isMobile">
                <div class="mini-cart-totals">
                  <ng-container *ngIf="showNetPrice$|async">
                    <div class="rower" *ngIf=" this.custIDService.fleetPrideGroup$|async as fleetPrideGroup">

                      <div class="prod-desc">
                        {{'common.popup_cart_customer_price'|cxTranslate}}</div>
                      <div class="price">
                        <span *ngIf="entry?.['product']?.netPrice?.formattedValue ; else OnPrice">
                          <strong>
                            {{entry?.['product']?.netPrice?.formattedValue}}&nbsp;&nbsp;{{entry?.['product']?.netPrice?.currencyIso}}
                          </strong>
                        </span>
                        <ng-template
                          #OnPrice><span><strong>{{'common.basket_page_poa'|cxTranslate}}</strong></span></ng-template>
                      </div>
                    </div>
                  </ng-container>

                  <div class=" rower">
                    <div class="prod-desc">
                      {{'common.popup_cart_quantity_added'|cxTranslate}} </div>
                    <div class="price">{{entry?.['quantity']}}</div>
                  </div>

                </div>
              </div>

            </div>

            <div class="cx-dialog-pickup-store" *ngIf="pickupStoreName">
              {{ 'pickupOptionDialog.modalHeader' | cxTranslate }}:
              <span class="cx-dialog-pickup-store-name">{{
                pickupStoreName
                }}</span>
            </div>
          </div>
          <!-- Separator -->
          <div class="
              cx-dialog-separator
              col-sm-12
              d-xs-block d-sm-block d-md-none
            "></div>
          <!-- Total container -->
          <div class="cx-dialog-actions col-sm-12 col-md-12" *ngIf="cart$ | async as cart">
            

            <!-- Actions -->
            <div class="cx-dialog-buttons downbuttons">
              <a [class.disabled]="form.dirty" [routerLink]="{ cxRoute: 'cart' } | cxUrl"
                (click)="dismissModal('View Cart click')" class="btn button" autofocus>{{ 'common.checkout_checkout' |
                cxTranslate }}
                <img src="/icons/link-dark-grey.svg" class="icon-right" alt=""></a>
              <a [class.disabled]="form.dirty" (click)="dismissModal('Proceed To Checkout click')"
                class="btn button-launch cart-text">{{ 'common.general_continue_shopping' | cxTranslate }}</a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- For screen reader purposes (not visual)-->
    <div class="cx-visually-hidden" aria-live="polite" aria-atomic="true">
      {{
      (addedEntryWasMerged$ | async)
      ? ('addToCart.basket_added_to_basket' | cxTranslate)
      : ('addToCart.basket_added_to_basket' | cxTranslate)
      }}
    </div>
  </div>
</div>